<template>
  <div class="available-cubes content">
    <a href="/" class="logo">
      <img :src="assetPath('logo.svg')" />
    </a>
    <h1 v-if="showSelection()" class="available-cubes__title">
      {{ t('availableCubes.title') }}
    </h1>
    <div v-else>{{ t('global.loading') }}</div>
    <ul v-if="showSelection()" class="available-cubes__list">
      <li
        :key="cube.cubeName"
        v-for="cube in availableCubes"
        class="available-cubes__item"
      >
        <a
          class="available-cubes__link"
          @click.prevent="appStore.selectCube({ cube: cube.cubeName, currentRoute: router.currentRoute.value })"
        >
          <!-- <img class="available-cubes__img" :src="cubeIconUrl(cube)" /> -->
          <h4 class="available-cubes__cube-title">{{ cube.nickName }}</h4>
          <caret :extraClasses="['caret-right']" direction="right" />
        </a>

      </li>
    </ul>

    <div class="available-cubes__logout">
      <a @click="logoutUser()">{{ t('global.logout') }}</a>
    </div>
  </div>
</template>

<script lang="ts">
  import { useRouter } from 'vue-router'
  import { useAuthStore } from '@/stores/useAuthStore'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useAccountStore } from '@/stores/useAccountStore'
  import { useAppStore } from '@/stores/useAppStore'
  import { useCubeStore } from '@/stores/useCubeStore'
  import { useMapStore } from '@/stores/useMapStore'
  import { computed } from 'vue'
  import { assetPath } from '@/util'
import type { CubeMapData } from '@/types/CubeDto'

  export default {
    name: 'select-cube',
    setup() {
      const router = useRouter()
      const authStore = useAuthStore()
      const { t } = useStrings()

      const accountStore = useAccountStore()
      const appStore = useAppStore()
      const cubeStore = useCubeStore()
      const mapStore = useMapStore()
      const availableCubes = computed(() => accountStore.availableCubes)

      return {
        router,
        authStore,
        t,
        availableCubes,
        appStore,
        cubeStore,
        mapStore,
        accountStore,
        assetPath,
      }
    },
    mounted() {
      if (this.cubeStore.isCubeSelected) {
        this.router.push({
          name: 'home',
        })
      }
    },
    methods: {
      showSelection() {
        return this.accountStore.availableCubes.length > 0
      },
      cubeIconUrl: function (rawCube) {
        const cube: Partial<CubeMapData> = {
          cubeName: rawCube.cubeName,
          // Since we don't have more info about the cubes at this point (yet)
          // we only show a generic image.
          hasProduction: false,
        }
        return this.mapStore.cubeIconUrl(cube, 'svg')
      },
      logoutUser: function () {
        this.authStore.logout()
      },
    },
  }
</script>

<style lang="scss">
  .available-cubes {
    max-width: 400px;
    margin: $spacer30 auto;

    .logo {
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-top: 5vh;
    }

    &__title {
      font-size: $font-size-lg;
      font-weight: $font-weight-base;
      text-align: center;
      transition: $transition-base;
      padding: 0 $spacer10;
      line-height: $line-height-sm;

      @media (min-width: $bp-ssm) {
        margin-top: $spacer40;
        margin-bottom: $spacer20;
      }
    }

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &__item {
      margin: 1.5rem $spacer05 1.5rem;
      background-color: #f8f8f8;
      color: #888;

      a {
        padding: 1.5rem;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-right: 1rem;
      }

      @media (min-width: $bp-ssm) {
        margin-bottom: $spacer05;
      }

      .caret-right {
        width: 1.5rem;
        height: 1.5rem;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    &__link {
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;

      justify-content: space-between;
      gap: 12px;
      text-decoration: none;
    }

    &__img {
      padding: 0;
      max-width: 50px;
      margin-right: $spacer05;
      flex-shrink: 0;

      @media (min-width: $bp-ssm) {
        max-width: 70px;
      }
    }

    &__cube-title {
      margin: 0;
      font-size: $font-size-lg;
      line-height: $line-height-min;
      transition: $transition-base;
      font-weight: normal;

      flex: 1;
      min-width: 0; /* wichtig für ellipsis in flex */
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;

      @media (min-width: $bp-ssm) {
        font-size: $font-size-xl;
      }
    }

    &__logout {
      margin-top: $spacer40;
      text-align: center;
    }
  }
</style>
